export const business = {
    name:"Cable Solutions Gyártó és Kereskedelmi Korlátolt Felelősségű Társaság",
    tax:"23753819-2-03",
    number:"03 09 123815",
    address:"6060 Tiszakécske, Dózsa telep 83.",
    postaddress:"6060 Tiszakécske, Dózsa telep 83.",
    email: "administration@cablesolutions.eu",
    phone: "(+31) 646 445 893",
  };